import {ChangeDetectionStrategy, Component} from '@angular/core';
import {Toast} from 'ngx-toastr';

@Component({
  selector: 'app-toastr',
  standalone: true,
  imports: [],
  templateUrl: './toastr.component.html',
  styleUrl: './toastr.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastrComponent extends Toast {

}
